module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAADgAAAAC98Dn6AAAAsklEQVQoFZ3SOwrCQBSF4Yl7SBvEBbgAi4BLMIWVjU1chRsIaeyt3Ih7SBPsFCy0MaClSPKfgCAh44we+PIg504exBj/zKiekSPwHUsoVljgiA2c0dAdJwyxxgNfo8fTnWKscMELKaz5HFJJgxrS3pq/hqYs9348rex1JxX3WOqAeA+NKV8xQgbnO9Fps2V7wxMF5nBmQEOfe4eJs90pBJ1z66mKEUJro/+C/llTov7RoQFvpTDDZqWh3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/motions/motion_mode_list_item_edit.png
// module id = pbAG
// module chunks = 6